import React from 'react'
import PropTypes from 'prop-types'
import CloseIcon from '@mui/icons-material/Close'
import { Box, Dialog, AppBar, Toolbar, IconButton } from '@mui/material'
import { t } from 'i18next'
import { trackingIframeUrlsByCompany } from 'Utils/constants'
import './OrderTrackingModal.css'
export default function OrderTrackingModal({
  open,
  onClose,
  companyID,
  invoiceNumber,
  trackingUrl,
}) {
  const baseUrlTracking = trackingIframeUrlsByCompany[companyID?.toUpperCase()]

  // Validar que sea una URL válida
  const isValidUrl =
    baseUrlTracking &&
    typeof baseUrlTracking === 'string' &&
    (baseUrlTracking.startsWith('http://') ||
      baseUrlTracking.startsWith('https://'))

  // Validar que existe URL válida y número de factura
  const isValidTracking = isValidUrl && invoiceNumber
  const orderUrlTracking = isValidTracking
    ? `${baseUrlTracking}/orders/${invoiceNumber}`
    : null

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      className="modal-tracking-wrapper">
      <AppBar className="app-bar-modal-tracking">
        <Toolbar>
          <IconButton
            edge="end"
            color="inherit"
            onClick={onClose}
            aria-label="close"
            className="icon-close-btn-tracking">
            <CloseIcon className="close-icon-modal-tracking" />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box
        className="iframe-tracking-container"
        style={{ marginLeft: 'var(--padding-left-bar)' }}>
        {isValidTracking && orderUrlTracking ? (
          <iframe
            title={t('DISPATCH_ORDER_T.ORDER_TRACKING')}
            src={orderUrlTracking}
            className="iframe-tracking-element"
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
          />
        ) : (
          <Box className="tracking-unavailable-message">
            <h2 className="title">Tracking no disponible</h2>
            <p className="description">
              No se encontró configuración de tracking para este despacho
            </p>
          </Box>
        )}
      </Box>
    </Dialog>
  )
}

OrderTrackingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  companyID: PropTypes.string.isRequired,
  invoiceNumber: PropTypes.string,
}
